import { h } from '@stencil/core';

export const readComponentsConfig = (order) => {
    return order.map(item => {
    // Split the item to get the component name and span
        let [name, span] = item.split(':');
        span = parseInt(span, 10);

        // Check if the key doesn't have ":" or doesn't have a valid span value (1 or 2)
        if (!item.includes(':') || isNaN(span) || (span !== 1 && span !== 2)) {
          span = 2; // Fallback span value
        }

        return { name, span };
    });
};
export const createDashboardLayout = (componentsInOrder, componentMap) => {
    const components = [];

    componentsInOrder.forEach(({ name, span }) => {
    // Get the component from the componentMap using the name
        const component = componentMap[name];
        if (component) {
          // Determine the class name based on the span
          const className = span === 2 ? 'grid-item double' : 'grid-item';

          // Push the component with its span, class name, and style to the components array
          components.push({ component, span, className });
        }
    });

    return components.map(({ component, className }, index) => (
      <div class={className} key={`${index}-${Math.random()}`}>
        {component}
      </div>
    ));
};

